// extracted by mini-css-extract-plugin
export default {"DecorativeTab":"DecorativeTab_DecorativeTab__q2C2z"};